module.exports = __webpack_public_path__ + "img/pencil-alt-vertical.6a4c1d3.png";